<template>
  <div>
    <div v-if="!form">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="page-header">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'vendorManagementDashboard' }">
                {{ $t('companyFormAdminView.vendorManagement') }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'vendorManagementFormList' }">
                {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name: 'vendorManagementFormManage', params:{id: form.id}}">
                {{ form.name }}
              </router-link>
            </li>
          </ol>
        </div>
      </div>

      <div class="card">
        <div
          v-if="editMain"
          class="card-body"
        >
          <form @submit.prevent="saveForm">
            <div class="mb-3">
              <label for="formName">{{ $t('companyFormEdit.formannAd') }}</label>
              <div>
                <input
                  id="formName"
                  v-model.trim="form.name"
                  name="name"
                  type="text"
                  class="form-control"
                  required
                >
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('companyFormEdit.tyinat') }}</label>
              <div>
                <select
                  v-model.trim="form.profileType"
                  class="form-control"
                  required
                  disabled
                >
                  <option value="SUPPLIER">
                    {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                  </option>
                  <option value="LOGISTIC">
                    {{ $t('companyFormEdit.logistiklrN') }}
                  </option>
                  <option value="TRUCK">
                    {{ $t('companyFormEdit.trSahiblriN') }}
                  </option>
                </select>
              </div>
            </div>

            <div
              v-if="form.profileType==='SUPPLIER'"
              class="mb-3"
            >
              <label>{{ $t('companySearch.faliyytSahlri') }}</label>
              <div>
                <Multiselect
                  v-model="sectors"
                  name="form_sectors"
                  :options="sectorList"
                  :multiple="true"
                  :label="$t('newTRKRequest.name')"
                  track-by="id"
                  :min="1"
                  :taggable="false"
                />
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('companyFormEdit.calculationOption') }}</label>
              <div>
                <div class="form-check">
                  <input
                    id="calculation-yes"
                    v-model="form.calculable"
                    class="form-check-input"
                    type="radio"
                    value="true"
                    required
                  >
                  <label
                    class="form-check-label"
                    for="calculation-yes"
                  >
                    {{ $t('companyFormEdit.calculate') }}
                  </label>
                </div>
                <div class="form-check">
                  <input
                    id="calculation-no"
                    v-model="form.calculable"
                    class="form-check-input"
                    type="radio"
                    value="false"
                    required
                  >
                  <label
                    class="form-check-label"
                    for="calculation-no"
                  >
                    {{ $t('companyFormEdit.notCalculate') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('companyFormEdit.qeydlr') }} </label>
              <div>
                <textarea
                  v-model.trim="form.description"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
            </div>

            <div class="mb-3">
              <button
                type="submit"
                class="btn btn-success mr-2"
              >
                {{ $t('sectorSelectionModal.yaddaSaxla') }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click="editMain= false;"
              >
                {{ $t('companyProfile.lvEt2') }}
              </button>
            </div>
          </form>
        </div>
        <div
          v-else
          class="card-body"
        >
          <h4>{{ form.name }}</h4>
          <div v-html="formDescription" />

          <div class="my-2">
            <div
              v-for="s in sectors"
              class="mb-2"
            >
              - {{ s.name }}
            </div>
          </div>

          <div class="mt-3">
            <button
              class="btn btn-sm btn-light-dark mr-3"
              @click="editMain=true"
            >
              {{ $t('companyFormAdminView.dyi') }}
            </button>
            <router-link
              :to="{name: 'vendorManagementFormManage', params:{id: form.id}}"
              class="btn btn-sm btn-light-success "
            >
              {{ $t('companyFormEdit.idaretm') }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="card my-4">
        <div class="card-header text-danger text-center">
          {{ $t('companyFormEdit.tdarkFormasnYaradarknBirTkMrhldnBlmVYaBirNeMrhldnB') }}
        </div>

        <div class="card-body">
          <p class="text-primary">
            {{ $t('companyFormEdit.pointInfo') }}
          </p>
          <b-tabs
            pills
            small
            card
          >
            <b-tab
              v-for="(s, i) in sectionPoints"
              :key="s.id"
              :active="i === 0"
            >
              <template #title>
                <!-- Tab Title with Points -->
                <span>
                  {{ form.calculable ? `${s.title} | ${s.point} ${$t('companyFormEdit.point')}` : s.title }}
                </span>
                <!-- Display remainingPoints message under title -->
                <div
                  :class="{
                    'text-danger': s.remainingPoints > 0,
                    'text-success': s.remainingPoints === 0
                  }"
                  class="small text-hover-white"
                >
                  {{ s.assignedPoints }} {{ $t('companyFormEdit.remainingPointsMessage') }}
                </div>
              </template>

              <!-- Tab Content -->
              <div class="mb-0">
                <div class="mb-3">
                  <button
                    class="btn btn-sm btn-outline-primary m-2"
                    @click="renameSection(s)"
                  >
                    {{ $t('companyFormEdit.mrhlninAdnDyi') }}
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger m-2"
                    @click="deleteSection(s)"
                  >
                    {{ $t('companyFormEdit.mrhlniSil') }}
                  </button>
                </div>
                <div
                  class="row"
                >
                  <div
                    v-for="(input, index) in sectionInputs[s.id]"
                    :key="input.hash"
                    draggable="true"
                    :class="`col-md-${JSON.parse(input.settings).size} ${'admin'}`"
                    class="blockItem mb-3 d-flex justify-content-between"
                    style="flex-direction: column;"
                    @dragstart="onDragStart(index, s.id)"
                    @dragover.prevent
                    @drop="onDrop(index, s.id)"
                  >
                    <VendorManagementInputView
                      :key="input.hash"
                      :input="input"
                      :is-admin="true"
                      @edit="editBlock(input)"
                      @delete="deleteBlock(input)"
                      @copy="copyBlock(s.id, index + 1, input)"
                      @addAfter="addNewBlock(s.id, index + 1)"
                    />
                  </div>
                </div>
                <div
                  v-if="sectionInputs[s.id].length < 1"
                  class="alert alert-light"
                >
                  <feather
                    type="info"
                    size="20"
                  />
                  {{ $t('companyFormEdit.buMrhlNBlokLavEdilmyib') }}
                </div>

                <div class="mt-3">
                  <div
                    class="addNewBlockButton"
                    @click="addNewBlock(s.id, sectionInputs[s.id].length + 1)"
                  >
                    <feather
                      type="plus"
                      size="12"
                    />
                    {{ $t('companyFormEdit.yeniBlok2') }}
                  </div>
                </div>
              </div>
            </b-tab>

            <template #tabs-end>
              <button
                class=" ml-3 btn btn-sm btn-success text-white"
                @click.prevent="createSection"
              >
                <span class="f-w-600">{{ $t('companyFormEdit.yeniMrhl') }}</span>
              </button>
            </template>
          </b-tabs>
        </div>
        <div class="card-footer">
          <button
            v-if="form.status === 'DRAFT'"
            type="button"
            class="btn btn-primary mr-2"
            @click.prevent="markReady"
          >
            {{ $t('companyFormEdit.formaHazrdr') }}
          </button>
          <button
            class="btn btn-success "
            @click="checkPointsAndRedirect"
          >
            {{ $t('companyFormEdit.idaretm') }}
          </button>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-form-create-input"
      centered
      size="xl"
      :title="$t('companyFormEdit.yeniBlok')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="createInput">
        <!-- Conditional rendering for 'Simple Questions' header -->
        <div
          v-if="!form?.calculable && newInput.inputType !== 'select'"
          class="row"
        >
          <div class="col-md-12">
            <h3>Sadə suallar</h3>
          </div>
        </div>

        <!-- Conditional rendering based on input type selection -->
        <div
          v-if="!form?.calculable && newInput.inputType !== 'select'"
          class="row"
        >
          <div class="col-md-6 mb-3">
            <label for="tipi">{{ $t('companyFormEdit.blokTipi') }}</label>
            <select
              id="tipi"
              v-model.trim="newInput.inputType"
              class="form-control"
              required
            >
              <option
                v-for="(v, k) in blockTypes"
                :key="k"
                :value="k"
              >
                {{ v }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="size">{{ $t('companyFormEdit.l') }}</label>
            <select
              id="size"
              v-model.number="newInput.settings.size"
              class="form-control"
              required
            >
              <option value="12">
                100%
              </option>
              <option value="9">
                75%
              </option>
              <option value="6">
                50%
              </option>
              <option value="4">
                33%
              </option>
              <option value="3">
                25%
              </option>
            </select>
          </div>
        </div>
        <!-- Evaluative Question Section -->
        <div
          v-if="form?.calculable"
          class="mb-3"
        >
          <h3>Qiymətləndirilməli suallar</h3>
          <button
            type="button"
            class="btn btn-info btn-sm"
            @click="setSelectInputType"
          >
            {{ $t('companyFormEdit.setToSelectType') }}
          </button>
        </div>

        <!-- Show question title input if input type is selected -->
        <div v-if="newInput.inputType">
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.balq') }}</label>
            <input
              v-model.trim="newInput.title"
              type="text"
              class="form-control"
              required
            >
          </div>

          <!-- Show points input if the question is evaluative and input type is 'select' -->
          <div
            v-if="form?.calculable && newInput.inputType === 'select'"
            class="mb-3"
          >
            <label>{{ $t('companyFormEdit.blokPoints') }}</label>
            <input
              v-model.number="newInput.point"
              type="number"
              class="form-control"
              required
              @input="validatePoints(newInput)"
            >
          </div>

          <!-- Show description input -->
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.qeydlr') }}</label>
            <div>
              <textarea
                v-model.trim="newInput.description"
                class="form-control"
                rows="3"
              />
            </div>
          </div>

          <div
            v-if="newInput.inputType === 'select'"
            class="mb-3 checkbox"
          >
            <b-form-checkbox v-model="newInput.settings.allowFileUpload">
              {{ $t('companyFormEdit.allowFileUpload') }}
            </b-form-checkbox>
          </div>

          <!-- Show select options if input type is 'select' -->
          <div
            v-if="newInput.inputType === 'select'"
            class="mb-3"
          >
            <div class="row">
              <div class="col-md-9">
                <h3 v-if="newInput.settings.options?.length>0">
                  Variantlar
                </h3>
              </div>
              <div class="col-md-3">
                <h5 v-if="newInput.settings.options?.length>0">
                  Dəyər faizləri
                </h5>
              </div>
            </div>

            <!-- Option inputs -->
            <div
              v-for="(option, index) in newInput.settings.options"
              :key="index"
              class="d-flex align-items-center mb-2"
            >
              <input
                v-model="option.text"
                type="text"
                class="form-control"
                placeholder="Option"
                required
              >
              <select
                v-model.number="option.percentage"
                class="form-control ml-2"
                style="width: 100px"
              >
                <option value="100">
                  100%
                </option>
                <option value="50">
                  50%
                </option>
                <option value="0">
                  0%
                </option>
              </select>

              <div
                v-if="newInput.settings.allowFileUpload"
                class="checkbox"
              >
                <b-form-checkbox
                  v-model="option.requireFile"
                  class="ml-2"
                >
                  {{ $t('companyFormEdit.requireFileForOption') }}
                </b-form-checkbox>
              </div>
              <button
                type="button"
                class="btn btn-danger btn-sm ml-2"
                @click="removeOption(newInput, index)"
              >
                {{ $t('companyFormEdit.removeOption') }}
              </button>
            </div>

            <br>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="addNewOption(newInput)"
            >
              {{ $t('companyFormEdit.addOption') }}
            </button>
          </div>

          <!-- File upload options for file type -->
          <div
            v-if="newInput.inputType === 'file'"
            class="row"
          >
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="newInput.settings.multiple"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.birNeFaylYklnBilr') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <!-- Visibility and required checkboxes -->
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="newInput.visible"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.grnn') }}
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div
                v-if="newInput.inputType !== 'info'"
                class="checkbox"
              >
                <b-form-checkbox
                  v-model="newInput.required"
                  name="checkboxRequired"
                >
                  {{ $t('companyFormEdit.doldurulmasMtlqdir') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <!-- Submit button -->
          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-success"
            >
              {{ $t('companyFormEdit.yarat') }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="modal-form-edit-input"
      centered
      :title="$t('companyFormEdit.blokRedaktsi')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form
        v-if="editInput"
        @submit.prevent="saveInput"
      >
        <!-- Row for input type and size -->
        <div class="row">
          <div
            class="col-md-6 mb-3"
          >
            <label>{{ $t('companyFormEdit.blokTipi') }}</label>
            <select
              v-model.trim="editInput.inputType"
              class="form-control"
              readonly
            >
              <option
                v-for="(v, k) in blockTypes"
                :key="k"
                :value="k"
              >
                {{ v }}
              </option>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label>{{ $t('companyFormEdit.l') }}</label>
            <select
              v-model.number="editInput.settings.size"
              class="form-control"
              required
            >
              <option value="12">
                100%
              </option>
              <option value="9">
                75%
              </option>
              <option value="6">
                50%
              </option>
              <option value="4">
                33%
              </option>
              <option value="3">
                25%
              </option>
            </select>
          </div>
        </div>

        <!-- Points input if form is calculable and inputType is 'select' -->
        <div
          v-if="form?.calculable && editInput.inputType === 'select'"
          class="mb-3"
        >
          <label>{{ $t('companyFormEdit.blokPoints') }}</label>
          <input
            v-model.number="editInput.point"
            type="number"
            class="form-control"
            required
            @focus="previousPoint = editInput.point"
            @input="validatePoints(editInput)"
          >
        </div>

        <!-- Block Title and Description -->
        <div class="mb-3">
          <label>{{ $t('companyFormEdit.balq') }}</label>
          <input
            v-model.trim="editInput.title"
            type="text"
            class="form-control"
            required
          >
        </div>
        <div class="mb-3">
          <label>{{ $t('companyFormEdit.qeydlr') }}</label>
          <textarea
            v-model.trim="editInput.description"
            class="form-control"
            rows="3"
          />
        </div>
        <div
          v-if="editInput.inputType === 'select'"
          class="mb-3 checkbox"
        >
          <b-form-checkbox v-model="editInput.settings.allowFileUpload">
            {{ $t('companyFormEdit.allowFileUpload') }}
          </b-form-checkbox>
        </div>
        <!-- Options for 'select' inputType -->
        <div
          v-if="editInput.inputType === 'select'"
          class="mb-3"
        >
          <div
            v-for="(option, index) in editInput.settings.options"
            :key="index"
            class="d-flex align-items-center mb-2"
          >
            <input
              v-model="option.text"
              type="text"
              class="form-control"
              placeholder="Option"
              required
            >
            <select
              v-model.number="option.percentage"
              class="form-control ml-2"
              style="width: 100px"
            >
              <option value="100">
                100%
              </option>
              <option value="50">
                50%
              </option>
              <option value="0">
                0%
              </option>
            </select>
            <div class="checkbox">
              <b-form-checkbox
                v-model="option.requireFile"
                class="ml-2"
              >
                {{ $t('companyFormEdit.requireFileForOption') }}
              </b-form-checkbox>
            </div>
            <button
              type="button"
              class="btn btn-danger btn-sm ml-2"
              @click="removeOption(editInput, index)"
            >
              {{ $t('companyFormEdit.removeOption') }}
            </button>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="addNewOption(editInput)"
          >
            {{ $t('companyFormEdit.addOption') }}
          </button>
        </div>

        <!-- Multiple file upload option for 'file' inputType -->
        <div
          v-if="editInput.inputType === 'file'"
          class="row"
        >
          <div class="col-md-6 mb-3">
            <div class="checkbox">
              <b-form-checkbox v-model="editInput.settings.multiple">
                {{ $t('companyFormEdit.birNeFaylYklnBilr') }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <!-- Visibility and Required Checkboxes -->
        <div class="row">
          <div class="col-md-6 mb-3 checkbox">
            <b-form-checkbox v-model="editInput.visible">
              {{ $t('companyFormEdit.grnn') }}
            </b-form-checkbox>
          </div>
          <div
            v-if="editInput.inputType !== 'info'"
            class="col-md-6 mb-3 checkbox"
          >
            <b-form-checkbox v-model="editInput.required">
              {{ $t('companyFormEdit.doldurulmasMtlqdir') }}
            </b-form-checkbox>
          </div>
        </div>

        <!-- Save Button -->
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-success"
          >
            {{ $t('sectorSelectionModal.yaddaSaxla') }}
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  companyFormAction,
  createFormInput,
  createFormSection,
  deleteFormInput,
  deleteFormSection,
  getMyForm,
  handleErrors,
  saveForm,
  saveFormInput,
  saveFormSection
} from "@/repositories/VendorManagementRepository";
import VendorManagementInputView from "@/pages/scc/vendorManagement/builder/VendorManagementInputView.vue";
import {getWorkingSectors} from "@/repositories/GeneralDataRepository";

import Multiselect from 'vue-multiselect'

export default {
  components: {VendorManagementInputView, Multiselect},
  data() {
    return {
      draggingIndex: null,
      draggingSectionId: null,
      previousPoint: 0,
      MAX_POINTS: 100, // Set your maximum allowed points here
      mediaBase: mediaBase,
      form: null,
      editMain: false,
      sectors: [],
      sections: [],
      inputs: [],
      sectionInputs: [],
      newInput: {
        sectionId: 0,
        listOrder: 0,
        inputType: '',
        title: '',
        description: '',
        required: false,
        visible: false,
        point: 0, // Add point property for each block
        settings: {
          size: 12,
          multiple: false,
          allowFileUpload: false, // Added for file upload checkbox
          values: '', // Concatenated answer string for backend
          options: [] // Store each option as an object with 'text', 'percentage', 'requireFile'
        }
      },
      editInput: {
        point: 0, // Add point property for each block
        settings: {
          values: '',
          options: [] // Store each option as an object with 'text', 'percentage', 'requireFile'
        }
      },
      blockTypes: this.$t("blockTypes"),
      sectorList: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    availablePoints() {
      // Determine if we're using `editInput` or `newInput`
      const activeInput = this.editInput?.companyFormSectionId ? this.editInput : this.newInput?.sectionId ? this.newInput : null;

      // Find the section that matches the companyFormSectionId
      let currentSection = this.sections.find(section =>
          this.editInput?.companyFormSectionId
              ? section.id === activeInput.companyFormSectionId
              : section.id === activeInput.sectionId
      );

      if (currentSection) {
        // Calculate the total points assigned in this section, excluding the points of `editInput` if we are editing
        let totalPointsAssigned = this.sectionInputs[currentSection.id].reduce((sum, block) => {
          // Exclude points of `editInput` itself if we’re editing
          if (activeInput === this.editInput && block.hash === this.editInput.hash) {
            return sum;
          }
          return sum + block.point;
        }, 0);

        // Available points are the section's max points minus the total assigned points
        return currentSection.point - totalPointsAssigned;
      }

      return 0;
    },
    formDescription() {
      return this.form && this.form.description
          ? this.form.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
          : '';
    },
    sectionPoints() {

      return this.sections.map((section) => {
        const assignedPoints = (this.sectionInputs[section.id] || []).reduce((sum, input) => sum + input.point, 0);
        const remainingPoints = section.point - assignedPoints;
        return {
          ...section,
          assignedPoints,
          remainingPoints,
        };
      });
    }
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
    sections: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
  },
  mounted() {
    this.getFormDetails();

    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectorList = ws.filter(s => s.parent === null);
    })
  },
  methods: {
    onDragStart(index, sectionId) {
      this.draggingIndex = index;
      this.draggingSectionId = sectionId;
    },
    onDrop(targetIndex, sectionId) {
      if (this.draggingSectionId === sectionId) {
        const inputs = this.sectionInputs[sectionId];
        const draggedItem = inputs[this.draggingIndex];

        // Remove the dragged item
        inputs.splice(this.draggingIndex, 1);

        // Insert it at the target index
        inputs.splice(targetIndex, 0, draggedItem);

        this.saveOrder(sectionId);
      }

      this.draggingIndex = null;
      this.draggingSectionId = null;
    },
    saveOrder(sectionId) {
      const inputs = this.sectionInputs[sectionId]; // Get inputs for the given section

      // Update the listOrder based on the current array index
      inputs.forEach((input, index) => {
        input.listOrder = index + 1; // Set listOrder (starting from 1)
      });

      // Send the updated order to the backend
      const promises = inputs.map(input => {
        return saveFormInput(
            this.token,
            input.id, // Unique identifier for the input
            this.form.id, // Current form ID
            input.companyFormSectionId, // Section ID
            input.inputType, // Input type (e.g., "text", "select")
            input.title, // Input title
            input.description, // Input description
            input.listOrder, // Updated listOrder
            input.required, // Whether the input is required
            input.visible, // Whether the input is visible
            JSON.parse(input.settings), // Additional settings for the input
            input.point // Points assigned to the input (if applicable)
        ).then(response => {
          if (response.code !== 200) {
            console.error(`Error saving input order for ID ${input.id}: ${response.message}`);
          }
        });
      });

      // Wait for all API calls to complete
      Promise.all(promises)
          .then(() => {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              icon: "success",
            }).then(() => {
              this.getFormDetails();
            });
          })
          .catch(error => {
            console.error("Error saving order:", error);
            this.$swal({
              title: this.$t("generalModal.errorTitle"),
              text: this.$t("companyFormEdit.orderSavedError"),
              icon: "error",
            });
          });
    },
    checkPointsAndRedirect() {
      const totalAssignedPoints = this.sectionPoints.reduce(
          (sum, section) => sum + section.assignedPoints,
          0
      );

      if (totalAssignedPoints < this.MAX_POINTS && this.form.calculable) {
        // Show popup message if points are insufficient
        this.$swal({
          title: this.$t("companyFormEdit.insufficientPointsTitle"),
          text: this.$t("companyFormEdit.insufficientPointsMessage"),
          icon: "warning",
          confirmButtonText: this.$t("generalModal.buttonCancel")
        });
      } else {
        // Navigate if points are sufficient
        this.$router.push({
          name: 'vendorManagementFormManage',
          params: {id: this.form.id}
        });
      }
    },
    setSelectInputType() {
      this.newInput.inputType = 'select';
    },
    validatePoints(input) {
      // Calculate available points for the relevant input
      const currentAvailablePoints = this.availablePoints;

      // Check if input point exceeds the available points
      if (input.point > currentAvailablePoints) {
        input.point = currentAvailablePoints;  // Restrict to available points

        // Show error if the point exceeds the allowable limit
        this.$swal({
          title: this.$t("err"),
          text: this.$t("companyFormEdit.merheleError", {point: currentAvailablePoints}),
          icon: "error"
        });
      }
    },
    addNewOption(input) {
      if (!input.settings.options) {
        this.$set(input.settings, 'options', []);  // Ensure reactivity
      }
      input.settings.options.push({
        text: '',
        percentage: 0,
        requireFile: false // Add requireFile initialization
      });
    },
    removeOption(input, index) {
      if (input.settings.options) {
        input.settings.options.splice(index, 1);
      }
    },
    formatOptions(input) {
      input.settings.values = input.settings.options
          .map(option => `${option.text} (${option.percentage}%)`)
          .join('\n');

    },
    calculateTotalPoints(excludeSectionId = null) {
      let totalPoints = 0;

      this.sections.forEach(section => {
        if (section.id !== excludeSectionId) {
          totalPoints += parseFloat(section.point) || 0;
        }
      });
      return totalPoints;
    },
    calculateSectionInputs() {
      let map = {};
      this.sections.forEach((s) => {
        map[s.id] = [];
      });
      this.inputs.forEach((i) => {
        i.hash = JSON.stringify(i);
        map[i.companyFormSectionId].push(i);
      });
      this.sectionInputs = map;
    },
    getFormDetails() {
      getMyForm(this.token, this.$route.params.id, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          this.form = data.form;
          this.sectors = data.sectors;
          this.sections = data.sections;
          this.inputs = data.inputs;
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },
    saveForm() {
      if (this.sectors.length < 1 && this.form.profileType === 'SUPPLIER') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("enAziFlyytShs"),
          icon: 'error'
        });
        return;
      }
      let sectors = this.sectors.map(elem => elem.id).join(",");

      saveForm(this.token, this.form.id, this.form.name, this.form.description, sectors, this.form.calculable).then(data => {
        if (data.code === 200) {
          this.editMain = false;
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },
    createSection() {
      const isCalculable = this.form.calculable;

      this.$swal({
        title: this.$t("companyFormEdit.newStage"),
        icon: 'question',
        html: `
          <label class="swal2-label">${this.$t("companyFormEdit.newStageText")}</label>
          <input id="new-stage-name" class="swal2-input">
          ${isCalculable ? `
            <label>${this.$t("companyFormEdit.bolmeninBali")}</label>
            <input id="point" class="swal2-input">` : ''
        }`,
        showCancelButton: true,
        confirmButtonText: this.$t("generalModal.buttonCreate"),
        cancelButtonText: this.$t("generalModal.buttonCancel"),
        preConfirm: () => {
          const stageName = document.getElementById('new-stage-name').value;
          let point = null;

          if (isCalculable) {
            point = document.getElementById('point').value;

            if (!point) {
              this.$swal.showValidationMessage( "Xal bos ola bilmez");
              return null;
            }

            if (point < 0) {
              this.$swal.showValidationMessage("0-dan kicik olmamalidir");
              return null;
            }

            if (point > 100) {
              this.$swal.showValidationMessage("100-dan boyuk olmamalidir");
              return null;
            }

            if (Number(this.calculateTotalPoints()) + Number(point) > 100) {
              this.$swal.showValidationMessage("Siz maksimum " + (100 - this.calculateTotalPoints()) + " bal verə bilərsiz");
              return null;
            }
          }
          if (!stageName) {
            this.$swal.showValidationMessage(this.$t("companyFormEdit.stageNameRequired"));
            return null;
          }
          return {stageName, point};
        }
      }).then((result) => {
        if (result.value) {
          const {stageName, point} = result.value;
          createFormSection(this.token, this.form.id, this.sections.length + 1, stageName, point).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    },
    createInput() {

      if (this.newInput.inputType === 'select' && this.newInput.settings.options === undefined || this.newInput.settings.options?.length === 0) {
        this.$swal({
          title: 'Error',
          icon: 'warning',
          text: 'Cavab variantlarını əlavə edin'
        })
        return;
      }
      if (this.newInput.settings.options && this.newInput.inputType === 'select') {
        this.formatOptions(this.newInput);
      }
      createFormInput(this.token, this.form.id, this.newInput.sectionId, this.newInput.inputType, this.newInput.title,
          this.newInput.description, this.newInput.listOrder, this.newInput.required, this.newInput.visible, this.newInput.settings, this.newInput.point).then(data => {
        if (data.code === 200) {
          this.addNewBlock(0, 0);
          this.getFormDetails();
          this.$bvModal.hide('modal-form-create-input');
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },
    saveInput() {
      if (this.editInput.inputType === 'select') {
        if (this.editInput.settings.options) {
          this.formatOptions(this.editInput);
      } else {
          this.$swal.showValidationMessage("Cavab variantlarını əlavə edin");
          return;
        }
        }

      saveFormInput(this.token, this.editInput.id, this.form.id, this.editInput.companyFormSectionId, this.editInput.inputType, this.editInput.title,
          this.editInput.description, this.editInput.listOrder, this.editInput.required, this.editInput.visible, this.editInput.settings, this.editInput.point).then(data => {
        if (data.code === 200) {
          this.editInput = null;
          this.getFormDetails();
          this.$bvModal.hide('modal-form-edit-input');
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },
    addNewBlock(sectionId, listOrder) {
      this.newInput = {
        sectionId,
        listOrder,
        inputType: '',
        title: '',
        description: '',
        required: false,
        visible: false,
        settings: {size: 12, allowFileUpload: false}
      };
      this.$bvModal.show('modal-form-create-input');
    },
    copyBlock(sectionId, listOrder, input) {
      let settings = JSON.parse(input.settings);

      this.newInput = {
        sectionId,
        listOrder,
        inputType: input.inputType,
        title: input.title,
        description: input.description,
        required: input.required,
        visible: input.visible,
        settings: {...settings}
      };

      this.$bvModal.show('modal-form-create-input');
    },
    editBlock(input) {
      this.editInput = {...input, settings: JSON.parse(input.settings)};
      this.$bvModal.show('modal-form-edit-input');
    },
    deleteBlock(input) {
      this.$swal({
        title: input.title,
        icon: 'question',
        text: this.$t("general.dltConfirm"),
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("slm"),
      }).then((result) => {
        if (result.value) {
          deleteFormInput(this.token, input.id).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
    renameSection(section) {
      const isCalculable = this.form.calculable;

      this.$swal({
        title: this.$t("companyFormEdit.mrhlninAdnDyi"),
        icon: 'question',
        html: `
          <label>${this.$t("companyFormEdit.newStageText")}</label>
          <input id="new-section-name" class="swal2-input" value="${section.title}">
          ${isCalculable ? `
            <label>${this.$t("companyFormEdit.bolmeninBali")}</label>
            <input id="new-section-points" class="swal2-input" type="number" value="${section.point}" min="0" max="100">
          ` : ''}`,
        showCancelButton: true,
        confirmButtonText: this.$t("generalModal.buttonCreate"),
        cancelButtonText: this.$t("generalModal.buttonCancel"),
        preConfirm: () => {
          const newTitle = document.getElementById('new-section-name').value;
          let newPoints = null;

          if (isCalculable) {
            newPoints = document.getElementById('new-section-points').value;

            const totalPoints = this.calculateTotalPoints(section.id);
            if (newPoints<section.assignedPoints) {
              this.$swal.showValidationMessage("Bu mərhələdə siz artıq "+ section.assignedPoints + " bal istifadə etmisiz. Azaltmaq olmaz");
              return null
            }
            if (totalPoints + Number(newPoints) > 100 || newPoints < 0 || newPoints > 100) {
              this.$swal.showValidationMessage(this.$t("companyFormEdit.maxPointExceeded"));
              return null;
            }
          }

          if (!newTitle) {
            this.$swal.showValidationMessage(this.$t("companyFormEdit.requiredFields"));
            return null;
          }
          return {newTitle, newPoints};
        }
      }).then((result) => {
        if (result.value) {
          const {newTitle, newPoints} = result.value;

          saveFormSection(this.token, section.id, this.form.id, newTitle, section.listOrder, newPoints).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    },
    deleteSection(section) {
      this.$swal({
        title: section.title,
        icon: 'question',
        text: this.$t("general.dltConfirm"),
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("slm"),
      }).then((result) => {
        if (result.value) {
          deleteFormSection(this.token, section.id).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
    markReady() {
      const totalAssignedPoints = this.sectionPoints.reduce(
          (sum, section) => sum + section.assignedPoints,
          0
      );

      // Step 2: Check if total assigned points are less than the maximum allowed points
      if (totalAssignedPoints < this.MAX_POINTS && this.form.calculable) {
        // Step 3: Show popup message if points are insufficient
        this.$swal({
          title: this.$t("companyFormEdit.insufficientPointsTitle"),
          text: this.$t("companyFormEdit.insufficientPointsMessage"),
          icon: "warning",
          confirmButtonText: this.$t("generalModal.buttonCancel")
        });
        return; // Exit the function if points are insufficient
      }
      if (this.inputs.length < 1) {
        this.$swal.fire({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("frmdHcBrSh"),
          icon: 'warning'
        })
        return;
      }

      let emptySectors = Object.values(this.sectionInputs).filter(s => s.length < 1);
      if (emptySectors.length > 0) {
        this.$swal.fire({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("hrBrMrhldAzi"),
          icon: 'warning'
        })
        return;
      }

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("companyFormEdit.modalText"),
        showCancelButton: true,
        confirmButtonText: this.$t("supplierOutgoingVendorRequest.hazrdr"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'ready', '').then(data => {
            if (data.code === 200) {
              this.$router.push({name: 'vendorManagementFormManage', params: {id: this.form.id}})
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.text-hover-white:hover {
  color: white !important;
}

.addNewBlockButton {
  padding: 20px;
  border: 1px dotted #474e50;
  background: #e9ecec;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: #a6afaf;
  }
}
</style>
